// PUBLIC LINKS — addresses that both a client component and a server ritual
// need to agree on, with NO other imports.
//
// ⚠️ WHY THIS FILE EXISTS. `CALENDLY` used to live in lib/rituals/feedbackProgram,
// which is a server module: it imports the Resend client and the delivery store,
// which read server-only env. The moment the landing footer imported the
// constant from there, the whole email stack was pulled into the CLIENT bundle
// and the build failed on server-only code in a browser chunk.
//
// A constant a public page renders belongs somewhere with no dependencies at
// all. Anything client-visible that a ritual also sends goes here — one
// definition, importable from either side.

/** twenty minutes with jonna — the booking door the feedback note opens and the
 *  landing footer offers. ONE calendar, so a changed link changes both. */
export const CALENDLY = "https://calendly.com/connect-innernet/30min";
